import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
    qualityScoreCategoryId: {
    label: string;
    values: {
      name: string;
      id: string;
      order: number;
      score:number;
    }[];
  };
  errorMessage: string;
  error: boolean;
  loading: boolean;
} = {
    qualityScoreCategoryId: {
    label: "",
    values: [],
  },
  error: false,
  loading: false,
  errorMessage: "",
};
const fetchQualityScoreCategoryId = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_SUCCESS: {
      console.log("action.qualityScoreCategoryId", action.qualityScoreCategoryId);
      return updateObject(state, {
        qualityScoreCategoryId: action.qualityScoreCategoryId,
        error: false,
        loading: false,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_STARTED:
      return updateObject(state, {
        qualityScoreCategoryId: initialState.qualityScoreCategoryId,
        error: false,
        loading: true,
        errorMessage: "",
      });

    case actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_FAILED:
      return updateObject(state, {
        qualityScoreCategoryId: initialState.qualityScoreCategoryId,
        error: true,
        loading: false,
        errorMessage: action.errorMessage,
      });

    case actionTypes.RESET_FETCH_QUALITY_SCORE_CATEGORY_ID:
      return updateObject(state, {
        qualityScoreCategoryId: initialState.qualityScoreCategoryId,
        error: false,
        loading: false,
        errorMessage: "",
      });

    default:
      return state;
  }
};

export default fetchQualityScoreCategoryId;
